import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import TextField from '@material-ui/core/TextField';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import Input from './Input';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import InputLabel from '@material-ui/core/InputLabel';

const style = (theme) => ({
  infoArea: {
    maxWidth: '360px',
    margin: '0 auto',
    padding: '0px',
    textAlign: 'center',
  },
  iconWrapper: {
    float: 'left',
    marginTop: '24px',
    marginRight: '10px',
  },
  // primary: {
  //   color: primaryColor
  // },
  // warning: {
  //   color: warningColor
  // },
  // danger: {
  //   color: dangerColor
  // },
  success: {
    color: '#4caf50',
  },
  // info: {
  //   color: infoColor
  // },
  // rose: {
  //   color: roseColor
  // },
  // gray: {
  //   color: grayColor
  // },
  icon: {
    width: '36px',
    height: '36px',
  },
  descriptionWrapper: {
    // color: grayColor,
    overflow: 'hidden',
  },
  title: {
    color: '#3C4858',
    margin: '1.75rem 0 0.875rem !important',
    marginTop: '30px',
    minHeight: 'unset',
    // font-family: "Roboto Slab", "Times New Roman", serif;
    fontWeight: 700,
    marginBottom: '25px',
    textDecoration: 'none',
    fontSize: '18px',
  },
  description: {
    // color: grayColor,
    overflow: 'hidden',
    marginTop: '0px',
    fontSize: '16px',
  },
  iconWrapperVertical: {
    float: 'none',
  },
  iconVertical: {
    width: '61px',
    height: '61px',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  displayErrors: {
    '& input': {
      // color: 'green',
      '&:invalid': {
        // backgroundColor: 'green',
        borderBottomColor: 'red',
        border: '1px solid red',
        '& label.Mui-focused': {
          color: 'green',
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: 'green',
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: 'red',
          },
          '&:hover fieldset': {
            borderColor: 'yellow',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'green',
          },
        },
      },
    },
  },
});

export default withStyles(style)(
  React.memo(function AddressForm(props) {
    // const [err, setError] = React.useState({})
    const [regID, setRegID] = React.useState('');

    const { reduxState, classes } = props;

    const handleSelectChange = (name, select) => {
      if (select) {
        reduxState.socialComunitiAction(name, select.id);
      }
    };

    const handleSelectChangeCallback = React.useCallback(
      (name) => (select) => {
        handleSelectChange(name, select);
      },
      []
    );

    React.useEffect(() => {
      if (reduxState.socialCommunity.regionId !== '') {
        reduxState.localityAction(reduxState.socialCommunity.regionId);
      }
    }, [reduxState.socialCommunity.regionId]); // this line fix

    const handleChange = (e) => {
      console.log(e.target.name, e.target.value);
      if (e.target.name === 'communityPhone') {
        reduxState.socialComunitiAction(e.target.name, e.target.value);
      } else {
        reduxState.socialComunitiAction(e.target.name, e.target.value);
      }
    };
    const validate = (state) => {
      return {
        //mobile: /((8|\+7)-?)?\(?\d{3}\)?-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}/.test(state.mobile),
        communityPhone: /^[+]?[\s.0-9]*[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(state.communityPhone),
        // communityPhone: /^['+', '3', '8', ' ', '(', '0', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]$/.test(state.communityPhone),
        communityEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          String(state.communityEmail).toLowerCase()
        ),
        iCodeRada: /^\d{8}$/.test(state.iCodeRada),

        // communityName: /^[a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ0-9]$/.test(state.communityName),
        // address: /^[a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ0-9]$/.test(state.address),
        // url: /^[a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ0-9]$/.test(state.url),
        communityName: /^$|^[0-9a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ' -.’`";:]+$/.test(state.communityName),
        address: /^$|^[0-9А-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ' -.’"`,;:]+$/.test(state.address),
        // url: /^[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/.test(state.url),
      };
    };

    const valid = validate(reduxState.socialCommunity);

    // const handleSelectAutocomplite = (e, select) => {

    //   let s = e.target.id;
    //   const n = s.indexOf('-');
    //   s = s.substring(0, n != -1 ? n : s.length);

    // };

    const handleChangeCallback = React.useCallback((e) => {
      handleChange(e);
    }, []);

    const filterOptions = (candidate, input) => {
      if (candidate.data.name.toLowerCase().includes(input.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    };

    const selectFilter = React.useMemo(() => filterOptions, []);

    return (
      <React.Fragment>
        <form onSubmit={props.handleNext} noValidate className={props.displayErrors ? classes.displayErrors : ''}>
          <Typography variant="h6" gutterBottom>
            Інформація про об’єднану територіальну громаду та її Голову
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={6}>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>ПІБ: </span>
                <span className={classes.description}>{reduxState.socialCommunity.commonName}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>ЄДРПОУ із КЕП : </span>
                <span className={classes.description}>{'' + reduxState.socialCommunity.iCodeSigner}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>Найменування організації: </span>
                <span className={classes.description}>{reduxState.socialCommunity.organization}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>Область: </span>
                <span className={classes.description}>{reduxState.socialCommunity.state}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>Населений пункт: </span>
                <span className={classes.description}>{reduxState.socialCommunity.locality}</span>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <Input
                required
                id="communityName"
                name="communityName"
                label="Найменування громади"
                fullWidth
                onChange={handleChangeCallback}
                value={reduxState.socialCommunity.communityName}
                autoComplete="fname"
                valid={!valid.communityName ? 1 : 0}
                // error={!err.communityName}
                inputProps={{ maxLength: 255 }}
              />
              {/* // validity */}
            </Grid>
            <Grid item xs={12}>
              <Input
                required
                id="address"
                name="address"
                label="Юридична адреса"
                fullWidth
                autoComplete="billing address-line1"
                onChange={handleChangeCallback}
                value={reduxState.socialCommunity.address}
                valid={!valid.address ? 1 : 0}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel htmlFor="formatted-text-mask-input">Офіційний телефон</InputLabel>
              <Input
                required
                phone
                id="communityPhone"
                name="communityPhone"
                label="Офіційний телефон "
                fullWidth
                autoComplete="nphone"
                onChange={handleChangeCallback}
                value={reduxState.socialCommunity.communityPhone}
                valid={!valid.communityPhone ? 1 : 0}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Input
                id="communityEmail"
                name="communityEmail"
                label="Адреса офіційної електронної пошти"
                fullWidth
                onChange={handleChangeCallback}
                value={reduxState.socialCommunity.communityEmail}
                required
                valid={!valid.communityEmail ? 1 : 0}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Input
                id="url"
                name="url"
                label="Офіційний сайт організації"
                fullWidth
                autoComplete="lurl"
                onChange={handleChangeCallback}
                value={reduxState.socialCommunity.url}
                // valid={!valid.url}
                inputProps={{ maxLength: 255 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Input
                required
                id="iCodeRada"
                name="iCodeRada"
                label="ЄДРПОУ ради, навколо, якої об'єдналася громада - "
                fullWidth
                // autoComplete="code"
                onChange={handleChangeCallback}
                value={reduxState.socialCommunity.iCodeRada}
                valid={!valid.iCodeRada ? 1 : 0}
                inputProps={{ maxLength: 10 }}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
          <TextField
            required
            id="count"
            name="count"
            label="Кількість модулів шифрування"
            fullWidth
            autoComplete="lcount"
            onChange={handleChange}
            value={reduxState.socialCommunity.count}
            pattern="\d+"
            // error={!err.count}
          />
        </Grid> */}
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Select
                value={reduxState.catalog.region.filter(({ id }) => id === reduxState.socialCommunity.regionId)}
                onChange={handleSelectChangeCallback('regionId')}
                options={reduxState.catalog.region}
                // styles={customStyles}
                // isMulti
                getOptionLabel={({ name, id }) => name}
                // noOptionsMessage={() => 'помилка серверу'}
                // menuPortalTarget={document.body}
                isSearchable={true}
                filterOption={selectFilter}
                // theme={customTheme}
                placeholder="Оберіть область"
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Select
                value={reduxState.catalog.locality.filter(({ id }) => id === reduxState.socialCommunity.spsznId)}
                onChange={handleSelectChangeCallback('spsznId')}
                options={reduxState.catalog.locality}
                // styles={customStyles}
                placeholder="Оберіть район"
                // isMulti
                getOptionLabel={({ name, id }) => (
                  <div>
                    <span>{name}</span>
                  </div>
                )}
                noOptionsMessage={() => 'помилка серверу'}
                menuPortalTarget={document.body}
                isSearchable={true}
                filterOption={selectFilter}
                // theme={customTheme}

                required
              />
            </Grid>
            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={
                    !valid.communityName ||
                    !valid.address ||
                    !valid.communityPhone ||
                    !valid.communityEmail ||
                    !valid.iCodeRada ||
                    !reduxState.socialCommunity.spsznId
                  }
                >
                  Далі
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </React.Fragment>
    );
  })
);
